export default "__VITE_ASSET__CsKlkBfR__"